
export const sendGA = PCH?.TAGMANAGER?.utaglink || (() => {});

export const getGAData = (name, location) => ({"tealium_event": "search", "click_name": `${name}`, "click_location": `${location}`});

export function searchBarGa() {
    switch (location.pathname) {
        case '/searchai':
            sendGA(getGAData('search icon', 'top search bar'));
            break;
        case '/searchcategory':
            sendGA(getGAData('search icon', 'top search bar'));
            break;
        case '/searchcategoryai':
            sendGA(getGAData('search now', 'top search bar'));
            break;
        case '/pysearch':
            sendGA(getGAData('serp pysearch', 'serp pysearch bar'));
            break;
        case '/search':
            sendGA(getGAData('serp search', 'serp search bar'));
            break;
    }
}

